var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgThemeType = function SvgThemeType(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#505050",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.8,
    d: "m9.721 19.2-1.696.891c-1.074.565-2.33-.347-2.125-1.544l.659-3.837a1.136 1.136 0 0 0-.327-1.005l-2.788-2.718c-.87-.847-.39-2.323.811-2.498l3.854-.56c.37-.054.69-.286.855-.621l1.723-3.492c.537-1.088 2.089-1.088 2.626 0l1.723 3.492c.166.335.486.567.855.621l3.854.56c1.2.175 1.68 1.65.811 2.498l-.25.244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.255 10.5 1.023 2.072a.674.674 0 0 0 .508.369l2.287.332a.87.87 0 0 1 .482 1.483L18.9 16.369a.673.673 0 0 0-.194.597l.39 2.278a.869.869 0 0 1-1.26.917l-2.047-1.076a.675.675 0 0 0-.627 0l-2.046 1.076a.87.87 0 0 1-1.261-.917l.39-2.278a.673.673 0 0 0-.194-.597l-1.655-1.613a.87.87 0 0 1 .482-1.483l2.287-.332c.22-.032.41-.17.508-.37l1.023-2.071a.87.87 0 0 1 1.56 0z"
  }))));
};

export default SvgThemeType;